import { useState, useEffect } from "react"
import { Modal, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Spinner from "react-bootstrap/Spinner"
import moment from "moment"
import api from "@/api/api"
import { ToastContainer, toast, Slide } from "react-toastify"
import { MdLock } from "react-icons/md"
import { RgbToHex } from "../displayColor"

interface UpgradePopupProps {
  show: boolean
  onHide: () => void
  upgradesText: string
  formValues?: any
  currentEventCreated: any
  setCurrentEventCreated: (value: any) => void
  type: string
}

export const UpgradeToPremiumPopup = ({
  show,
  onHide,
  upgradesText,
  formValues,
  currentEventCreated,
  setCurrentEventCreated,
  type,
}: UpgradePopupProps) => {
  const { t } = useTranslation()
  const [loadingPremium, setLoadingPremium] = useState(false)
  const handleSaveInvite = async () => {
    setLoadingPremium(true)

    let currentEvent: any = {}
    try {
      const formatDate = moment(new Date()).format("Y-MM-DD")
      const formatTime = moment(new Date()).format("HH:mm")
      const eventValues = {
        source: "invite_smart",
        guestType: "chooseType",
        orientation: "v",
        name: formValues?.eventName,
        simplified: true,
        host_name: "host",
        event_created_date: formatDate,
        event_created_time: formatTime,
        address: {
          address: "Unknown",
          lat: "24.7136",
          lng: "46.6753",
        },
        text_style: {
          font_family: "Oxygen, sans-serif",
          font_size: "2x 1",
          font_style: {
            textBold: false,
            textItalic: false,
            textUnderline: false,
          },
          color: "#000",
          text_align: "center",
        },
        text_position: "flex-start",
        // start_datetime: dayjs
        //   .utc(totalData?.start_datetime)
        //   .format("YYYY-MM-DD HH:mm:ss"),
        venue: "",
        language: "ar",
        // type: totalData?.eventType,
        image_id: "", // Use the uploaded imageId here
        invitation_show_qr_code: true,
        guests_position_x: "",
        guests_position_y: "",
        guests_width_height: "",
        qr_position_x: "",
        qr_position_y: "",
        qr_width_height: "",
        image_width_height: "",
      }

      if (type == "add") {
        if (currentEventCreated && currentEventCreated !== null) {
          const newEventValues = {
            ...eventValues,
            event_id: currentEventCreated?.event_id,
            allow_to_add_invitation_to_wallets: 0,
          }
          const eventRes: any = await api.events.createEvent(newEventValues)
          if (eventRes?.status == 200) {
            setCurrentEventCreated(eventRes?.data?.data)
            currentEvent = eventRes?.data?.data
          }
        } else {
          const eventRes: any = await api.events.createEvent(eventValues)
          if (eventRes?.status == 200) {
            setCurrentEventCreated(eventRes?.data?.data)
            currentEvent = eventRes?.data?.data
          }
        }
      } else {
        currentEvent = currentEventCreated
      }
      console.log("currentEventCreated", currentEventCreated)
      console.log("currentEvent", currentEvent)
      const body = {
        priceId: "price_1QRqNQCykVN8e2WmnN20XvWi",
        successUrl: "https://dev-api.mazoom.sa/api/stripe/payment/success",
        mode: "payment",
        eventId: currentEvent?.event_id,
        txnType: "invitationUpgrade",
      }

      const response = await api.events.subscribeForEvent(body)
      if (response?.status) {
        // setLoading(false) // Set the loading index to the current button's index
        setLoadingPremium(false)

        const url = response?.data?.checkout_url

        if (url) {
          setLoadingPremium(false)

          onHide()
          window.open(url, "_blank")
        } else {
          setLoadingPremium(false)

          toast.error("Something went wrong: Invalid URL", {
            position: "top-right",
            transition: Slide,
            autoClose: 2000, // 3 seconds
            closeButton: false, // Removes the close button
          })
        }
      } else {
        setLoadingPremium(false)

        toast.error("Something went wrong: Response status not OK", {
          position: "top-right",
          transition: Slide,
          autoClose: 2000, // 3 seconds
          closeButton: false, // Removes the close button
        })
      }
    } catch (error) {
      setLoadingPremium(false)
      toast.error("Something went wrong: Response status not OK", {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
    } finally {
      setLoadingPremium(false)
    }
  }
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        closeButton
        onHide={onHide}
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingTop: "20px",
        }}
      >
        <h5></h5>
      </Modal.Header>
      <Modal.Body
        style={{}}
        className="w-100 mb-4 d-flex flex-column justify-content-center align-items-center gap-0"
      >
        <div>
          <h5 className="mb-2 pb-2 text-center d-flex justify-content-center">
            {upgradesText?.toLowerCase() === "fonts" && (
              <h5 className="fw-bold w-100 m-0 p-0 mt-0 d-flex flex-wrap align-items-center justify-content-center gap-1 text-center">
                <span className="ms-1">{t("invitation.font")}</span>
                <span className="ms-1">{t("invitation.selection")}</span>
                <span className="ms-1">{t("invitation.notAvailable")}</span>
              </h5>
            )}
            {upgradesText?.toLowerCase() === "colors" && (
              <h5 className="fw-bold w-100 m-0 p-0 mt-0 d-flex flex-wrap align-items-center justify-content-center gap-1 text-center">
                <span className="ms-1">{t("invitation.color")}</span>
                <span className="ms-1">{t("invitation.selection")}</span>
                <span className="ms-1">{t("invitation.notAvailable")}</span>
              </h5>
            )}
            {upgradesText?.toLowerCase() === "logo_removal" && (
              <h5 className="fw-bold m-0 p-0 mt-0 d-flex flex-wrap align-items-center justify-content-center gap-1">
                {t("invitation.logoRemoval")}
                <span className="ms-1">{t("invitation.notAvailable")}</span>
              </h5>
            )}
          </h5>
          <div
            className="ps-4 pe-4 m-0 w-100"
            style={{
              width: "300px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            {upgradesText?.toLowerCase() === "fonts" && (
              <h5
                style={{ fontSize: "16px" }}
                className="w-100 d-flex flex-row flex-wrap align-items-center"
              >
                <span className="text-muted d-flex me-1">
                  {t("invitation.inOrderToEnableAll")}
                </span>
                <span className="text-muted d-flex me-1">
                  {t("invitation.fonts")}
                </span>
                <span className="text-muted d-flex">
                  {t("invitation.pleaseUpgradeYourPlan")}
                </span>
              </h5>
            )}
            {upgradesText?.toLowerCase() === "logo_removal" && (
              <h5
                style={{ fontSize: "16px" }}
                className="m-0 p-0 mt-0 d-flex flex-wrap align-items-center gap-1"
              >
                <span className="d-flex">
                  {t("invitation.inOrderToEnable")}
                </span>
                <span className="d-flex">{t("invitation.thisFeature")}</span>
                <span className="d-flex">
                  {t("invitation.pleaseUpgradeYourPlan")}
                </span>
              </h5>
            )}
            {upgradesText?.toLowerCase() === "colors" && (
              <h5
                style={{ fontSize: "16px" }}
                className="w-100 d-flex flex-row flex-wrap align-items-center"
              >
                <span className="text-muted d-flex me-1">
                  {t("invitation.inOrderToEnableAll")}
                </span>
                <span className="text-muted d-flex me-1">
                  {t("invitation.colors")}
                </span>
                <span className="text-muted d-flex">
                  {t("invitation.pleaseUpgradeYourPlan")}
                </span>
              </h5>
            )}
            <div className="d-flex flex-column gap-3">
              <Button
                className="d-flex mt-3"
                style={{ backgroundColor: "#20529B", color: "#ffffff" }}
                disabled={loadingPremium}
                onClick={handleSaveInvite}
              >
                {loadingPremium ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <span>{t("buttons.upgradeInvitationToPremium")}</span>
                )}
              </Button>
              <Button
                className="d-flex"
                style={{ backgroundColor: "#20529B", color: "#ffffff" }}
                disabled={loadingPremium}
                onClick={handleSaveInvite}
              >
                {t("buttons.chooseASubscriptionPlan")}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
